import {
    IModelingSessionCalculatorCalculateOptions,
    IModelingSessionCalculatorCalculateResults,
    IModelingSessionCalculator
} from "../PA.Model.Core/PA.Model.IF.Aspects";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {ProgressProvider} from "../PA.Core/Basic/Progress";
import {ModelingSessionBO} from "../PA.Model.BusinessObjects/ModelingSessionBO";
import {BehaviorSubject, Subscription} from "rxjs";
import * as _ from "lodash";
import {ASync} from "../PA.Core/Basic/ASync";
import {IMessageProvider, IProgressProvider, MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {IBusinessObject} from "../PA.Core/PA.Core.IF.BO";
import {ModelingSessionService} from "./ModelingSessionService";



export class ModelingSessionCalculator
    implements IModelingSessionCalculator {

    private _calcMessageProvider: MessageProvider;
    private _calcProgressProvider: ProgressProvider;
    private _calcComplete: BehaviorSubject<ModelingSessionCalculator>;
    private _modelingSessionBO: ModelingSessionBO


    private _bIsLoaded: boolean

    //   private _CalculateCompleteSubscription: Subscription
    constructor() {
        this._calcMessageProvider = new MessageProvider()
        this._calcProgressProvider = new ProgressProvider()
        this._calcComplete = new BehaviorSubject<ModelingSessionCalculator>(this)
        this._modelingSessionBO = undefined
        this._bIsLoaded = false

        //      this._CalculateCompleteSubscription = undefined
    }

    Register(modelingSessionBO: ModelingSessionBO): void {
        const self = this
        const bo = modelingSessionBO
        // Currently, we don't listen to anything,.. just on demand calc.

        this.UnRegister()
        this._modelingSessionBO = modelingSessionBO

        if (bo) {
            bo.OnLoadComplete
                .then((result) => {
                    return ASync.resolve()
                })
                .then((ignore) => {

                    // Subscribe
                    self._bIsLoaded = true
                })
                .catch((err) => {
                    console.log("Error in Model Evaluator Register(): ", err)
                    self._bIsLoaded = false
                })
        }
    }

    UnRegister(): void {
        this._modelingSessionBO = undefined
        this._bIsLoaded = false

    }

    private get bIsLoaded(): boolean {
        return this._bIsLoaded
    }


    get CalcProgressProvider(): IProgressProvider {
        return this._calcProgressProvider
    }

    get CalcMessageProvider(): IMessageProvider {
        return this._calcMessageProvider
    }

    get OnCalculateComplete(): BehaviorSubject<ModelingSessionCalculator> {
        return this._calcComplete
    }


    Calculate(opts: IModelingSessionCalculatorCalculateOptions): Promise<IModelingSessionCalculatorCalculateResults> {
        const self = this

        return new Promise<IModelingSessionCalculatorCalculateResults>((resolve, error) => {
            let aBO: ModelingSessionBO = self._modelingSessionBO
            if (_.isEmpty(aBO)) {
                resolve()
                return
            }

            self.CalcMessageProvider.clearMessages()
            self.CalcProgressProvider.start("Calculating Trial")
            self.CalcProgressProvider.setProgressMessage('Saving', 'Validating and Saving Model')
            // 1. Save (Validate)
            let savePromise: Promise<IBusinessObject> = undefined
            savePromise = aBO.Save()


            savePromise
                .then((bo) => {
                    if (!bo.bIsSaved) {
                        self.CalcProgressProvider.setProgressMessage('Saving', 'Unable to Save Modeling Session to Calculate')
                        self.CalcProgressProvider.finish()
                        return
                    }

                    // 2. Run Model Evaluator
                    self.CalcProgressProvider.setProgressMessage('Calculating', 'Calculating Trial')

                    let aModelingSessionService = new ModelingSessionService()
                    return aModelingSessionService.CalculateTrial(opts.WB_MODELING_SESSION_TRIAL_ID,{ })
                })
                .then((results) => {
                    if (!aBO.bIsSaved) {
                        return
                    }

                    if (results.bSuccess) {
                        self.CalcMessageProvider.addMessage({
                            code: 'Success', type: MessageType.Information,
                            title: 'Calculation Trial Completed', description: 'Calculating Trial Completed'
                        })
                    }
                    // Add Any Warnings
                    self._calcMessageProvider.addTextMessages('CalcW', MessageType.Warning, results.sWarnings);

                    // Add Any Errors
                    self._calcMessageProvider.addTextMessages('CalcE', MessageType.Error, results.sErrors)

                })
                .then(() => {
                    self.CalcProgressProvider.finish()
                    //
                })
                .then(() => {
                    self.OnCalculateComplete.next(self)
                    resolve({})
                })
                .catch((err) => {
                    self.CalcProgressProvider.exception(err)
                    error(err)
                })

        })
    }
}


